export const S3HOST =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com';
// export const GA_ID = 'UA-157807664-1';
export const GA_ID = 'UA-52365165-39';

export const OYO_LIFE_BASE_URL = "https://partner.oyolife.in/";

export const HMS_LOGIN_URL = 'https://www.oyoos.com/sign_up';
